import type { Token } from 'marked'

export const TTS_ENDPOINT = 'https://services.habysmol.com/tts'

export async function fetchTtsMp3(text: string, signal?: AbortSignal): Promise<Blob> {
  const res = await fetch(TTS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text }),
    signal,
  })
  if (!res.ok) {
    throw new Error(`TTS failed: ${res.status}`)
  }
  return res.blob()
}

/** Markdown lexer token → payload text for TTS (prefer full markdown slice). */
export function tokenTextForTts(token: Token): string | null {
  const t = token as { raw?: string; type?: string; text?: string }
  const raw = typeof t.raw === 'string' ? t.raw.trim()
    .replace("**Translator:** AtlasStudios **Editor:** AtlasStudios", "").replace("**Translator:** Atlas Studios **Editor:** Atlas Studios", "") : ''
  const text = typeof t.text === 'string' ? t.text.trim()
    .replace("**Translator:** AtlasStudios **Editor:** AtlasStudios", "").replace("**Translator:** Atlas Studios **Editor:** Atlas Studios", "") : ''
  if (t.type === 'space' || t.type === 'hr') return null
  if (raw.length > 0) return raw
  if (text.length > 0) return text
  return null
}

export function shouldSkipTtsToken(token: Token): boolean {
  return tokenTextForTts(token) == null
}
